import { Component, Inject, OnInit } from '@angular/core';
import {
   MatDialog,
   MatDialogRef,
   MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportService } from 'src/app/sharedModule/report-v2/services/report.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { saveAs } from 'file-saver';

@Component({
   selector: 'app-source-preview',
   templateUrl: './source-preview.component.html',
   styleUrls: ['./source-preview.component.scss'],
})
export class SourcePreviewComponent implements OnInit {
   documentContent: string[];
   processedContent: SafeHtml;
   pdfSrc;
   requestPurpose;
   enablePII = false;
   deletedFromArchive = false;
   title;
   user;
   institution;
   creationDate;
   allowExternalDownload = false;
   fromkopinor = false;
   constructor(
      private reportService: ReportService,
      public dialogRef: MatDialogRef<SourcePreviewComponent>,
      public dialog: MatDialog,
      private spinnerService: NgxSpinnerService,
      private sanitizer: DomSanitizer,
      /**
       * Used to pass data in component through dialog
       */
      @Inject(MAT_DIALOG_DATA) public data: any
   ) { }

   ngOnInit(): void {
      this.pdfSrc = this.data.presignedS3UrlPreview;
      this.documentContent = this.data.documentContent;
      if (this.documentContent['deletedFromArchive']) {
         this.deletedFromArchive = true;
         this.processedContent = this.sanitizer.bypassSecurityTrustHtml(this.documentContent['content']);
      }  else {
            this.deletedFromArchive = false;
         this.processedContent = this.sanitizer.bypassSecurityTrustHtml(this.documentContent['content']);  
      }
      if(this.data.fromkopinor){
         this.fromkopinor = true;
      }
      if(this.data.fromMigratedData || this.data.fromkopinor){
      this.title = this.data.title;
      this.user = this.data.author;
      this.institution = this.data.institution;
      this.creationDate = this.data.createdAt;
      } else {
         this.title = this.data.submission?.title;
         this.user = this.data.submission?.author || this.data.submissionUserDetails.name;
         this.institution = this.data.submissionUserDetails.Institution?.name || '//';
         this.creationDate = this.data.submission?.createdAt?.split('T')[0];
      }
      this.processDocumentContent(this.data.documentContent)

      const documentInstitutionSettings = this.data.submissionUserDetails?.Institution?.InstitutionSettings?.[0];
      this.allowExternalDownload = documentInstitutionSettings?.allowExternalDownload || false;
   }

   processDocumentContent(content: any): SafeHtml {
      this.enablePII = content['enablePII'];
      if (this.enablePII && content['content']) {
         const cleanContent = content['content'].replace(/^"|"$/g, '');
         const contentLines = cleanContent.split('" "');
         const htmlContent = contentLines.map(text => {
            const processedText = text.replace(/<(\w+)>/g, '<span class="pii">&lt;$1&gt;</span>');
            return `<div>${processedText}</div>`;
         }).join('');

         return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
      } else {
         return this.sanitizer.bypassSecurityTrustHtml('');
      }
   }

   callBackFn(pdf: PDFDocumentProxy) {
   }

   downloadExternalDocument(): void {
      const submissionId = this.data.submission?.id;
      if (!submissionId) {
         return;
      }
      this.spinnerService.show();
      this.reportService
         .downloadOriginalDocument(submissionId)
         .pipe()
         .subscribe(
            (data: any) => {
               saveAs(data.urlToDownload, this.title || 'document.pdf');
               this.spinnerService.hide();
            },
            (error: any) => {
               console.error('Error downloading external document:', error);
               this.spinnerService.hide();
            }
         );
   }

   submit() {
      this.spinnerService.show()
      this.reportService
         .sentContentRequest(
            this.data.sourceId,
            this.data.submissionId,
            this.requestPurpose,
            this.data.index,
            this.data.submission.id,
            this.data.institutionId
         )
         .pipe()
         .subscribe(
            (data) => {
               this.data = data
               this.spinnerService.hide();

            },
            (error) => {
               this.spinnerService.hide();
            }
         );
   }
}
